/**
 *  @class 
 *  @function FacetsToggle
 */    
    function updateRangeInputs(paramName) {
                                           
    if (document.getElementById('mb-filter.p.m.cus.hgt')) {
    }
    
    // Check if the min element exists before accessing its dataset
    const minElement = document.getElementById('min-' + paramName);
    if (!minElement || !minElement.dataset.values) {
        return; // Exit early if element doesn't exist or has no dataset
    }
    
    const rawValues = JSON.parse(minElement.dataset.values);
    const sortedValues = rawValues.map(Number).sort((a, b) => a - b);
      
      // Update the min and max values based on sorted values
      const minValue = sortedValues[0];
      const maxValue = sortedValues[sortedValues.length - 1];

      // Set attributes for range inputs
      const minInput = document.getElementById('min-' + paramName);
      const maxInput = document.getElementById('max-' + paramName);
      const minFilterInput = document.getElementById('min-Filter-' + paramName);
      const maxFilterInput = document.getElementById('max-Filter-' + paramName);
      
      // Check if all required elements exist
      if (!minInput || !maxInput || !minFilterInput || !maxFilterInput) {
          return; // Exit early if any required element is missing
      }
      
      // const minInput = document.getElementById('min-' + paramName);
      // const maxInput = document.getElementById('max-' + paramName);
      minInput.setAttribute('min', minValue);
      minInput.setAttribute('max', maxValue);
      maxInput.setAttribute('min', minValue);
      maxInput.setAttribute('max', maxValue);
      
      // Only set slider defaults here.
      // Do not force values into the text inputs (field__input),
      // because that fights the user while editing.
      if (!minInput.value) minInput.value = minValue;
      if (!maxInput.value) maxInput.value = maxValue;
      
      // Update data-values attributes with sorted values
      minInput.dataset.values = JSON.stringify(sortedValues);
      maxInput.dataset.values = JSON.stringify(sortedValues);
      minFilterInput.dataset.values = JSON.stringify(sortedValues);
      maxFilterInput.dataset.values = JSON.stringify(sortedValues);
    }
function facetChipLabel(anchor) {
    const clone = anchor.cloneNode(true);
    clone.querySelectorAll('span, svg').forEach(el => el.remove());
    return clone.textContent.replace(/\s+/g, ' ').trim();
}

function removeHeightFilterAnchors() {
    // One chip per centimetre would flood the bar. Collapse those into a
    // single "15 cm – 50 cm" chip. "Alles verwijderen" is hidden by CSS when
    // it is the only child, so the range chip has to stay.
    document.querySelectorAll('facet-remove').forEach(container => {
        const numeric = [];
        container.querySelectorAll('a.active-facets__button').forEach(anchor => {
            if (anchor.dataset.rangeChip === 'true') return;
            if (/^\d+$/.test(facetChipLabel(anchor))) numeric.push(anchor);
        });
        if (!numeric.length) return;

        const values = numeric.map(anchor => parseInt(facetChipLabel(anchor), 10));
        const min = Math.min(...values);
        const max = Math.max(...values);
        const icon = numeric[0].querySelector('span');
        const clearUrl = new URL(numeric[0].href, window.location.origin);
        ['filter.p.m.cus.hgt', 'filter.p.m.cus.hgt.gte', 'filter.p.m.cus.hgt.lte', 'filter.p.m.cus.dmt', 'filter.p.m.cus.dmt.gte', 'filter.p.m.cus.dmt.lte'].forEach(key => {
            clearUrl.searchParams.delete(key);
        });

        numeric.forEach(anchor => anchor.remove());

        const chip = document.createElement('a');
        chip.className = 'active-facets__button';
        chip.dataset.rangeChip = 'true';
        chip.href = `${clearUrl.pathname}${clearUrl.search}`;
        chip.appendChild(document.createTextNode(`${min} cm – ${max} cm`));
        if (icon) chip.appendChild(icon.cloneNode(true));
        chip.addEventListener('click', (event) => {
            event.preventDefault();
            const form = container.closest('facet-filters-form') || document.querySelector('facet-filters-form');
            if (form) form.onActiveFilterClick(event);
        });
        const clearAll = container.querySelector('.active-facets__button-remove');
        container.insertBefore(chip, clearAll);
    });
}
function updateProductDisplay(minSliderValue, maxSliderValue) {
const productItems = document.querySelectorAll('#product-grid .column');
let itemsPerPage =  productsPerPage; 
    // Filter products based on slider values
    const filteredItems = Array.from(productItems).filter(item => {
        const filter = parseFloat(item.dataset.height);
        return filter >= minSliderValue && filter <= maxSliderValue;
    });
    // const filteredItems = Array.from(productItems).filter(item => {
    //     const height = parseFloat(item.dataset.height);
    //     const dimension = parseFloat(item.dataset.dimension);
    //     return height >= minHeight && height <= maxHeight && dimension >= minDimension && dimension <= maxDimension;

    // Calculate total pages based on filtered items
    const totalPages = Math.ceil(filteredItems.length / itemsPerPage);

    // Hide all products first
    productItems.forEach(item => item.style.display = 'none');

    // Show only the filtered products for the current page
    filteredItems.forEach(item => {
        item.style.display = ''; // Show the product
    });

 
}


function updateRangeSliderValues(paramName, filterValues) {

    if (paramName.includes('min-Filter')) {
        const minSlider = document.getElementById(paramName.replace('-Filter', ''));
        const minRangeSlider = document.getElementById(paramName);
        minSlider.value = minRangeSlider.value;
    } else {
        const maxSlider = document.getElementById(paramName.replace('-Filter', ''));
        const maxRangeSlider = document.getElementById(paramName);
        maxSlider.value = maxRangeSlider.value;
    }

    // Clean up paramName for further use
    paramName = paramName.replace('min-Filter-', '').replace('max-Filter-', '');

    // Call updateSliderValues with the modified parameter name
    updateSliderValues(paramName, filterValues);
    updateUrlParams(paramName, filterValues);
}

// Function to handle slider value updates
function updateSliders(minSlider, maxSlider, selectedRange, rangeSelected, minRangeSlider, maxRangeSlider) {
    // Ensure minSlider value does not exceed maxSlider value
    if (parseFloat(minSlider.value) > parseFloat(maxSlider.value)) {
        const selectedMaxSlider = maxSlider.value;
        maxSlider.value = minSlider.value;
        minSlider.value = selectedMaxSlider;
    }

    // Ensure maxSlider value does not fall below minSlider value
    if (parseFloat(maxSlider.value) < parseFloat(minSlider.value)) {
        const selectedMaxSlider = maxSlider.value;
        maxSlider.value = minSlider.value;
        minSlider.value = selectedMaxSlider;
    }

    // Update min and max range sliders
    if (minRangeSlider) {
        minRangeSlider.value = minSlider.value;
    }
    if (maxRangeSlider) {
        maxRangeSlider.value = maxSlider.value;
    }

    if (selectedRange) {
        selectedRange.textContent = `${minSlider.value} cm - ${maxSlider.value} cm`;
    }

    const leftPercentage = ((minSlider.value - minSlider.min) / (minSlider.max - minSlider.min)) * 100;
    const rightPercentage = ((maxSlider.value - minSlider.min) / (minSlider.max - minSlider.min)) * 100;

    if (rangeSelected) {
        rangeSelected.style.left = `${leftPercentage}%`;
        rangeSelected.style.right = `${100 - rightPercentage}%`;
    }
}

function updateSliderValues(paramName, filterValues) {
    // Check if paramName includes 'mb' and replace 'mb-' prefix if it does
    const useMbSliders = paramName.includes('mb');
    const modifiedParamName = useMbSliders ? paramName.replace('mb-', '') : paramName;

    // Select sliders based on the condition
    const minSlider = useMbSliders ? document.getElementById(`min-mb-${modifiedParamName}`) : document.getElementById(`min-${modifiedParamName}`);
    const maxSlider = useMbSliders ? document.getElementById(`max-mb-${modifiedParamName}`) : document.getElementById(`max-${modifiedParamName}`);
    const selectedRange = useMbSliders ? document.getElementById(`selected-mb-${modifiedParamName}`) : document.getElementById(`selected-${modifiedParamName}`);
    const rangeSelected = useMbSliders ? document.getElementById(`range-mb-${modifiedParamName}`) : document.getElementById(`range-${modifiedParamName}`);
    const minRangeSlider = useMbSliders ? document.getElementById(`min-Filter-mb-${modifiedParamName}`) : document.getElementById(`min-Filter-${modifiedParamName}`);
    const maxRangeSlider = useMbSliders ? document.getElementById(`max-Filter-mb-${modifiedParamName}`) : document.getElementById(`max-Filter-${modifiedParamName}`);

    // Check if required sliders exist before updating
    if (!minSlider || !maxSlider) {
        return; // Exit early if required sliders don't exist
    }

    // Update sliders
    updateSliders(minSlider, maxSlider, selectedRange, rangeSelected, minRangeSlider, maxRangeSlider);


}


function updateUrlParams(paramName, filterValues) {
    const minSlider = document.getElementById(`min-${paramName}`);
    const maxSlider = document.getElementById(`max-${paramName}`);
    if (!minSlider || !maxSlider) return;

    // Do not write "min+-+max" into the address bar. Shopify list filters only
    // accept one value per param (filter.p.m.cus.hgt=100), and a plus-range
    // matches nothing — a load of that URL returns 0 products and drops
    // filters already applied, such as plant type. The facet form expands the
    // range into real values and updates the URL on submit.
}

// Function to update URL parameters
function updateUrlParam(paramName, values) {
    let currentUrl = new URL(window.location.href);

    // Clear existing parameters
    currentUrl.searchParams.delete(paramName);

    if (values) {
        values.forEach(value => {
            const separator = currentUrl.search ? '&' : '?';
            currentUrl.search += `${separator}${value}`;
        });
    }

    // Push the new URL state
    history.pushState(null, '', currentUrl.toString());
}

function setRangeFromUrl() {
    const currentUrl = new URL(window.location.href);
    const filterMap = {};

    // Collect filter parameters
    ['hgt', 'dmt'].forEach((slug) => {
        const base = `filter.p.m.cus.${slug}`;
        const gte = currentUrl.searchParams.get(`${base}.gte`);
        const lte = currentUrl.searchParams.get(`${base}.lte`);
        if (gte != null && lte != null && gte !== '' && lte !== '') {
            filterMap[base] = [`${gte} - ${lte}`];
            filterMap[`mb-${base}`] = [`${gte} - ${lte}`];
        }
    });

    for (const [key, value] of currentUrl.searchParams.entries()) {
        if (filterMap[key]) continue;
        if (key === 'filter.p.m.cus.hgt'  || key === 'mb-filter.p.m.cus.hgt' ) {
            if (!filterMap[key]) filterMap[key] = [];
            filterMap[key].push(value);
        }
    }

    const minMaxMap = {};

    ['filter.p.m.cus.hgt', 'mb-filter.p.m.cus.hgt'].forEach(key => {
        const filterParam = filterMap[key];
        if (!filterParam) return;

        const nums = [];
        filterParam.forEach(raw => {
            String(raw).split(/\s*(?:\+-+|-)\s*/).forEach(part => {
                const n = parseFloat(part);
                if (!isNaN(n)) nums.push(n);
            });
        });
        if (nums.length) {
            minMaxMap[key] = { min: Math.min(...nums), max: Math.max(...nums) };
        }
    });

    // Cache DOM elements to reduce lookups
    const elements = {};
    for (const key in minMaxMap) {
        elements[`min-${key}`] = document.getElementById(`min-${key}`);
        elements[`max-${key}`] = document.getElementById(`max-${key}`);
        elements[`selected-${key}`] = document.getElementById(`selected-${key}`);
        elements[`range-${key}`] = document.getElementById(`range-${key}`);
    }

    // Set sliders and range display
    for (const key in minMaxMap) {
        const { min, max } = minMaxMap[key];
        const minSlider = elements[`min-${key}`];
        const maxSlider = elements[`max-${key}`];
        const selectedRange = elements[`selected-${key}`];
        const rangeSelected = elements[`range-${key}`];
        const minRangeSlider = document.getElementById(`min-Filter-${key}`);
        const maxRangeSlider = document.getElementById(`max-Filter-${key}`);

        // Check if required elements exist before updating
        if (minSlider && maxSlider) {
            minSlider.value = min;
            maxSlider.value = max;

            if (selectedRange) {
                selectedRange.textContent = `${minSlider.value} cm - ${maxSlider.value} cm`;
            }
            
            if (minRangeSlider && maxRangeSlider) {
                maxRangeSlider.value = max;
                minRangeSlider.value = min;
            }

            // Calculate percentages for the range slider
            const sliderMin = parseFloat(minSlider.min);
            const sliderMax = parseFloat(maxSlider.max);
            const leftPercentage = ((min - sliderMin) / (sliderMax - sliderMin)) * 100;
            const rightPercentage = ((max - sliderMin) / (sliderMax - sliderMin)) * 100;

            if (rangeSelected) {
                rangeSelected.style.left = `${leftPercentage}%`;
                rangeSelected.style.right = `${100 - rightPercentage}%`;
            }
        }
    }
}
    

    removeHeightFilterAnchors();
    if (document.getElementById('min-mb-filter.p.m.cus.hgt')) {
    document.addEventListener('DOMContentLoaded', updateRangeInputs('mb-filter.p.m.cus.hgt'));
    // document.addEventListener('DOMContentLoaded', updateRangeInputs('mb-filter.p.m.cus.dmt'));
    }else {
    document.addEventListener('DOMContentLoaded', updateRangeInputs('filter.p.m.cus.hgt'));
    // document.addEventListener('DOMContentLoaded', updateRangeInputs('filter.p.m.cus.dmt'));
    }
    document.addEventListener('DOMContentLoaded', setRangeFromUrl);
class FacetsToggle {
  constructor() {
    this.container = document.getElementById('Facet-Drawer');
    let button = document.getElementById('Facets-Toggle');

    // Add functionality to buttons
    if (button) {
      button.addEventListener('click', (e) => {
   //     e.preventDefault();
   //     document.getElementsByTagName("body")[0].classList.toggle('open-cc');
  //    this.container.classList.toggle('active');
      });
    }
  }
}


class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const form = this.querySelector('form');
    if (!form) return;

    const heightTextInputIds = new Set([
      'min-Filter-filter.p.m.cus.hgt',
      'max-Filter-filter.p.m.cus.hgt',
      'min-Filter-mb-filter.p.m.cus.hgt',
      'max-Filter-mb-filter.p.m.cus.hgt',
    ]);

    form.addEventListener('input', (event) => {
      const t = event.target;
      if (t && t.id && heightTextInputIds.has(t.id)) return;
      this.debouncedOnSubmit(event);
    });
    
    // Add change event listener for checkboxes specifically
    form.addEventListener('change', (event) => {
      if (event.target.type === 'checkbox') {
        this.onSubmitHandler(event);
      }
      // Apply the height/diameter slider when the pointer is released.
      // The debounced "input" handler can resolve against a slider that
      // a previous filter response has already removed.
      if (event.target.type === 'range' && event.target.id && event.target.id.indexOf('filter.p.m.cus.') !== -1) {
        this.onSubmitHandler(event);
      }
    });

    this.bindRangeControls();
  }

  bindRangeControls() {
    const form = this.querySelector('form');
    if (!form) return;
    const heightTextInputIds = [
      'min-Filter-filter.p.m.cus.hgt',
      'max-Filter-filter.p.m.cus.hgt',
      'min-Filter-mb-filter.p.m.cus.hgt',
      'max-Filter-mb-filter.p.m.cus.hgt',
    ];
    const applyHeightTextInput = (inputEl) => {
      if (!inputEl || inputEl.dataset.hgtHandlerAttached === 'true') return;
      inputEl.dataset.hgtHandlerAttached = 'true';

      const submitFromInput = () => {
        if (inputEl.value.trim() === '') return;
        this.onSubmitHandler({ preventDefault() {}, target: inputEl });
      };
      const debouncedSubmit = debounce(submitFromInput, 800);

      inputEl.addEventListener('input', (e) => {
        e.stopPropagation();
        debouncedSubmit();
      });
      inputEl.addEventListener('change', (e) => {
        e.stopPropagation();
        submitFromInput();
      });
      inputEl.addEventListener('blur', () => {
        submitFromInput();
      });
    };
    heightTextInputIds.forEach((id) => applyHeightTextInput(form.querySelector(`#${CSS.escape(id)}`)));
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    if (searchParams == null) searchParams = '';
    searchParams =
      typeof searchParams === 'string'
        ? FacetFiltersForm.fixMetafieldRangeParamEncoding(searchParams)
        : FacetFiltersForm.fixMetafieldRangeParamEncoding(String(searchParams));

    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const container = document.getElementsByClassName('thb-filter-count');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    for (var item of container) {
      item.classList.add('loading');
    }

    // Address bar stays min/max, same shape as price (gte + lte).
    // Shopify's height metafield is a list, so only the section request
    // is expanded into the individual values that list accepts.
    const fetchParams = FacetFiltersForm.expandMetafieldRangesForFetch(searchParams);
    const requestId = (FacetFiltersForm.latestRequest = (FacetFiltersForm.latestRequest || 0) + 1);

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${fetchParams}`;
      const filterDataUrl = element => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event, requestId);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event, requestId);
      }
    });
    FacetFiltersForm.searchParamsPrev = searchParams;
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event, requestId) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        if (requestId !== FacetFiltersForm.latestRequest) return;
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
          html,
          url
        }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);

        new FacetsToggle();

      });
  }

  static renderSectionFromCache(filterDataUrl, event, requestId) {
    if (requestId !== FacetFiltersForm.latestRequest) return;
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {

    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    
    // Only call updateRangeInputs if the elements exist
    if (document.getElementById('min-filter.p.m.cus.hgt')) {
        updateRangeInputs('filter.p.m.cus.hgt'); 
    }
    // updateRangeInputs('filter.p.m.cus.dmt'); 
    
    if (document.getElementById('min-mb-filter.p.m.cus.hgt')) {
        updateRangeInputs('mb-filter.p.m.cus.hgt'); 
    }
    // updateRangeInputs('mb-filter.p.m.cus.dmt'); 
    
    setRangeFromUrl(); 
    removeHeightFilterAnchors();
    document.querySelectorAll('facet-filters-form').forEach((facetForm) => facetForm.bindRangeControls());
  }

  static renderProductCount(html) {
    const countHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.getElementsByClassName('thb-filter-count');

    if (countHtml) {
      for (var item of container) {
        item.innerHTML = countHtml.innerHTML;
        item.classList.remove('loading');
      }
    }

  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm collapsible-row, #FacetFiltersFormMobile collapsible-row');
    const activeRow = event && event.target && event.target.closest
      ? event.target.closest('collapsible-row')
      : null;
    const matchesIndex = (element) => {
      if (!activeRow || !activeRow.isConnected) return false;
      return element.dataset.index === activeRow.dataset.index;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const formId = element.closest('form') && element.closest('form').id;
      const selector = formId
        ? `#${formId} collapsible-row[data-index="${element.dataset.index}"]`
        : `collapsible-row[data-index="${element.dataset.index}"]`;
      document.querySelectorAll(selector).forEach((targetElement) => {
        targetElement.innerHTML = element.innerHTML;
      });
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender && activeRow && activeRow.isConnected) {
      FacetFiltersForm.renderCounts(countsToRender, activeRow);
    }
    document.querySelectorAll('facet-filters-form').forEach((facetForm) => facetForm.bindRangeControls());
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      const destination = document.querySelector(selector);
      if (!activeFacetsElement || !destination) return;
      destination.innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-filter-count'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({
      searchParams
    }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  /**
   * Turn filter.p.m.cus.hgt.gte / .lte into repeated list values for the
   * section fetch only. The browser URL keeps the two range params.
   */
  static expandMetafieldRangesForFetch(queryString) {
    const params = new URLSearchParams(queryString);
    ['hgt', 'dmt'].forEach((slug) => {
      const base = `filter.p.m.cus.${slug}`;
      let start = parseInt(params.get(`${base}.gte`), 10);
      let end = parseInt(params.get(`${base}.lte`), 10);
      params.delete(`${base}.gte`);
      params.delete(`${base}.lte`);

      if (Number.isNaN(start) || Number.isNaN(end)) {
        const compact = params.get(base) || '';
        const match = String(compact).match(/(\d+)\s*(?:\+-+|-)\s*(\d+)/);
        if (!match) return;
        start = parseInt(match[1], 10);
        end = parseInt(match[2], 10);
        params.delete(base);
      } else {
        params.delete(base);
      }

      const el =
        document.getElementById(`min-filter.p.m.cus.${slug}`) ||
        document.getElementById(`min-mb-filter.p.m.cus.${slug}`);
      const raw = el && el.getAttribute('data-values');
      if (raw) FacetFiltersForm.rangeValueCache[slug] = raw;
      const cached = raw || FacetFiltersForm.rangeValueCache[slug];
      const allowed = cached ? JSON.parse(cached).map((v) => Number(v)) : [];
      const seen = new Set();
      allowed.forEach((value) => {
        if (value < start || value > end || seen.has(value)) return;
        seen.add(value);
        params.append(base, String(value));
      });
    });
    return params.toString();
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }];
  }

  /**
   * URLSearchParams.toString() encodes "+" as "%2B". Shopify metafield range filters
   * expect literal plus signs (e.g. filter.p.m.cus.hgt=75+-+300), and expandRange's
   * regex matches that shape. Restore "+" only for known Hoogte/Diameter params.
   */
  static fixMetafieldRangeParamEncoding(queryString) {
    if (!queryString || typeof queryString !== 'string') return queryString;
    const keys = [
      'filter.p.m.cus.hgt',
      'filter.p.m.cus.dmt',
      'mb-filter.p.m.cus.hgt',
      'mb-filter.p.m.cus.dmt',
    ];
    let s = queryString;
    for (const key of keys) {
      const esc = key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      s = s.replace(new RegExp(`(${esc}=)([^&]*)`, 'g'), (_, prefix, val) => prefix + val.replace(/%2B/gi, '+'));
    }
    return s;
  }

  /**
   * Range sliders update the URL on "change" (release), but the facet form submits on
   * debounced "input". The first fetch can run before the URL has the new range.
   * Sync Hoogte/Diameter from the live slider DOM into the request params.
   */
  static syncMetafieldRangeParamsFromDom(currentParams, event) {
    const tid = event && event.target && event.target.id ? event.target.id : '';
    const useMobile = tid.includes('mb-');
    // "mb-" is only a DOM id prefix. Shopify's param is always filter.p.m.cus.*
    const specs = [
      { param: 'filter.p.m.cus.hgt', id: useMobile ? 'mb-filter.p.m.cus.hgt' : 'filter.p.m.cus.hgt' },
      { param: 'filter.p.m.cus.dmt', id: useMobile ? 'mb-filter.p.m.cus.dmt' : 'filter.p.m.cus.dmt' },
    ];

    specs.forEach(({ param, id }) => {
      const minEl = document.getElementById(`min-${id}`);
      const maxEl = document.getElementById(`max-${id}`);
      if (!minEl || !maxEl) return;

      const minV = parseInt(minEl.value, 10);
      const maxV = parseInt(maxEl.value, 10);
      const lo = parseInt(minEl.min, 10);
      const hi = parseInt(maxEl.max, 10);
      if (Number.isNaN(minV) || Number.isNaN(maxV) || Number.isNaN(lo) || Number.isNaN(hi)) return;

      currentParams.delete(param);
      currentParams.delete(`${param}.gte`);
      currentParams.delete(`${param}.lte`);
      currentParams.delete(id);
      if (minV === lo && maxV === hi) return;

      currentParams.set(`${param}.gte`, String(minV));
      currentParams.set(`${param}.lte`, String(maxV));
    });
  }

  onSubmitHandler(event) {
    event.preventDefault();
    if (event.target.id && event.target.id.includes('-Filter-') ) {
      updateRangeSliderValues(event.target.id, event.target.dataset.values)
    }
    
    const form = event.target.closest('form');
    const formData = new FormData(form);
    const searchParams = new URLSearchParams(formData);
    const currentUrl = window.location.href;
    const paramsIndex = currentUrl.indexOf('?');
    const currentParams = paramsIndex > -1 ? new URLSearchParams(currentUrl.substring(paramsIndex)) : new URLSearchParams();

    FacetFiltersForm.syncMetafieldRangeParamsFromDom(currentParams, event);

    // Get all existing filter parameters and store unique values
    const existingFilters = {};
    for (const [key, value] of currentParams) {
      if (key.includes('filter.')) {
        if (!existingFilters[key]) {
          existingFilters[key] = new Set();
        }
        existingFilters[key].add(value);
      }
    }

    // Get the checkbox that triggered the event
    const checkbox = event.target.type === 'checkbox' ? event.target : event.target.querySelector('input[type="checkbox"]');
    const isUnchecking = checkbox && !checkbox.checked;
    
    // If we're unchecking a checkbox, we need to handle it specially
    if (isUnchecking && checkbox) {
      const checkboxName = checkbox.name;
      const checkboxValue = checkbox.value;
      
      // Remove this specific value from existing filters
      if (existingFilters[checkboxName]) {
        existingFilters[checkboxName].delete(checkboxValue);
      }
      
      // Clear all existing values for this filter and add back the remaining ones
      currentParams.delete(checkboxName);
      if (existingFilters[checkboxName] && existingFilters[checkboxName].size > 0) {
        existingFilters[checkboxName].forEach(v => currentParams.append(checkboxName, v));
      }
    }

    // Handle new form data (for checked checkboxes and other inputs)
    for (const [key, value] of searchParams) {
      if (key === 'filter.v.price.gte' || key === 'filter.v.price.lte') {
        const priceValue = parseFloat(value).toFixed(2);
        if (priceValue !== "0.00" && priceValue !== parseFloat(document.querySelector('.price_slider').dataset.max).toFixed(2)) {
          currentParams.set(key, priceValue);
        }
      } else if (key.includes('filter.')) {
        // For filter parameters, add the value (this handles checked checkboxes)
        const existingValues = existingFilters[key] || new Set();
        existingValues.add(value);
        
        // Clear existing values for this filter and add back all values
        currentParams.delete(key);
        existingValues.forEach(v => currentParams.append(key, v));
      } else {
        currentParams.set(key, value);
      }
    }
    
    // Only remove min price if it's exactly 0.00
    if (searchParams.get('filter.v.price.gte') === "0.00") {
      currentParams.delete('filter.v.price.gte');
    }
    
    // Only remove max price if it matches the slider max exactly (comparing with 2 decimal places)
    if (document.querySelector('.price_slider')) {
      const sliderMax = parseFloat(document.querySelector('.price_slider').dataset.max).toFixed(2);
      const currentMax = searchParams.get('filter.v.price.lte');
      if (currentMax && parseFloat(currentMax).toFixed(2) === sliderMax) {
        currentParams.delete('filter.v.price.lte');
      }
    }
    
    FacetFiltersForm.renderPage(currentParams.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.rangeValueCache = {};
FacetFiltersForm.latestRequest = 0;
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();


class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('a').forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
      });
    });
  }
}

customElements.define('facet-remove', FacetRemove);

/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {

  constructor() {
    super();
  }
  connectedCallback() {
    let slider = this.querySelector('.price_slider'),
      amounts = this.querySelector('.price_slider_amount'),
      args = {
        start: [parseFloat(slider.dataset.minValue || 0), parseFloat(slider.dataset.maxValue || slider.dataset.max)],
        connect: true,
        step: 0.01,
        range: {
          'min': 0,
          'max': parseFloat(slider.dataset.max)
        },
        format: {
          to: function(value) {
            return parseFloat(value).toFixed(2);
          },
          from: function(value) {
            return parseFloat(value);
          }
        }
      },
      event = new CustomEvent('input'),
      form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');

    if (slider.classList.contains('noUi-target')) {
      slider.noUiSlider.destroy();
    }
    noUiSlider.create(slider, args);

    slider.noUiSlider.on('update', function (values) {
      amounts.querySelector('.field__input_min').value = values[0];
      amounts.querySelector('.field__input_max').value = values[1];
    });
    slider.noUiSlider.on('change', function (values) {
      form.querySelector('form').dispatchEvent(event);
    });
  }
}
customElements.define('price-slider', PriceSlider);

window.addEventListener('load', () => {
  new FacetsToggle();
});

document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('click', function(event) {
        // Check if the clicked target is the Facets-Toggle
        if (event.target.closest('#Facets-Toggle')) {
            event.preventDefault(); // Prevent the default anchor behavior
            var facetDrawer = document.getElementById('Facet-Drawer');
            if (facetDrawer) {
                facetDrawer.classList.add('active'); 
            }
        } else {
            // Stop propagation and do nothing in else
            event.stopPropagation();
        }
    });
});




function updateHeightFilterFromUrl() {
  const url = new URL(window.location.href);
  const searchParams = url.searchParams;
  
  const gte = searchParams.get('filter.p.m.cus.hgt.gte');
  const lte = searchParams.get('filter.p.m.cus.hgt.lte');
  const heightFilterValues = (gte != null && lte != null && gte !== '' && lte !== '')
    ? [gte, lte]
    : Array.from(searchParams.entries())
    .filter(([key]) => key === 'filter.p.m.cus.hgt')
    .map(([, value]) => value);
  
  if (heightFilterValues && heightFilterValues.length > 0) {
    let minValue, maxValue;
    
    if (heightFilterValues.length === 1 && heightFilterValues[0].includes('+-+')) {
      const [min, max] = heightFilterValues[0].split('+-+').map(value => parseInt(value));
      minValue = min;
      maxValue = max;
    } else {
      const numericValues = heightFilterValues
        .filter(value => /^\d+$/.test(value))
        .map(value => parseInt(value))
        .filter(value => !isNaN(value));
      
      if (numericValues.length > 0) {
        minValue = Math.min(...numericValues);
        maxValue = Math.max(...numericValues);
      }
    }
    
    if (minValue !== undefined && maxValue !== undefined) {
      const minInput = document.getElementById('min-Filter-filter.p.m.cus.hgt');
      const maxInput = document.getElementById('max-Filter-filter.p.m.cus.hgt');
      
      const minSlider = document.getElementById('min-filter.p.m.cus.hgt');
      const maxSlider = document.getElementById('max-filter.p.m.cus.hgt');
      
      const selectedRange = document.getElementById('selected-filter.p.m.cus.hgt');
      const rangeSelected = document.getElementById('range-filter.p.m.cus.hgt');
      
      // Check if all required elements exist before updating
      if (minInput && maxInput && minSlider && maxSlider) {
        minInput.value = minValue;
        maxInput.value = maxValue;
        
        minSlider.value = minValue;
        maxSlider.value = maxValue;
        
        if (selectedRange) {
          selectedRange.textContent = `${minValue} - ${maxValue}`;
        }
        
        if (rangeSelected) {
          const sliderMin = parseFloat(minSlider.min);
          const sliderMax = parseFloat(maxSlider.max);
          const leftPercentage = ((minValue - sliderMin) / (sliderMax - sliderMin)) * 100;
          const rightPercentage = ((maxValue - sliderMin) / (sliderMax - sliderMin)) * 100;
          rangeSelected.style.left = `${leftPercentage}%`;
          rangeSelected.style.right = `${100 - rightPercentage}%`;
        }
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  updateHeightFilterFromUrl();

  const params = new URLSearchParams(window.location.search);
  let collapsed = false;
  ['hgt', 'dmt'].forEach((slug) => {
    const base = `filter.p.m.cus.${slug}`;
    if (params.has(`${base}.gte`)) return;
    const values = params.getAll(base).map((v) => parseInt(v, 10)).filter((n) => !Number.isNaN(n));
    if (values.length < 2) return;
    params.delete(base);
    params.set(`${base}.gte`, String(Math.min(...values)));
    params.set(`${base}.lte`, String(Math.max(...values)));
    collapsed = true;
  });

  const short = params.toString();
  const hasRange = ['hgt', 'dmt'].some((slug) => params.has(`filter.p.m.cus.${slug}.gte`));
  if (!hasRange) return;

  if (collapsed) {
    history.replaceState({ searchParams: short }, '', `${window.location.pathname}?${short}`);
  }
  // gte/lte match the price-filter URL, but this metafield is a list, so Shopify
  // ignores them on a full page load. Re-fetch with the expanded list and keep
  // the short URL in the address bar.
  FacetFiltersForm.renderPage(short, null, false);
});


